import React from'react';
import {observer} from 'mobx-react-lite'
import clubStore from '../../../storage/ClubStore'
import {Link} from "react-router";
import appStore from "../../../storage/AppStore";
import {closeOffcanvas} from '../../../common/utils'

const ManagerMenu = () => {
  if (!(clubStore.club.is_manager || clubStore.club.is_branch_manager)) return null;
  return (
    <div style={{"minWidth": "190px"}}>
        <div className="h6 mb-2">
            <span>{appStore.tr.manager}</span>
        </div>
        {clubStore.club.is_manager &&
            <ul className="nav flex-row gap-2 mt-0" style={{"maxHeight": "200px", "overflowY": "auto"}}>
                {/*<li className="d-flex w-100 pt-1">*/}
                {/*    <Link to="/manager/member/new"*/}
                {/*          className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"*/}
                {/*          onClick={() => {*/}
                {/*              closeOffcanvas()*/}
                {/*          }}>*/}
                {/*        <i className="ci ci-user-plus me-2"/>*/}
                {/*        <span>{appStore.tr.add_member}</span>*/}
                {/*    </Link>*/}
                {/*</li>*/}
                <li className="d-flex w-100 pt-1">
                    <Link to="/manager/member/list"
                          className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"
                          onClick={() => {
                              closeOffcanvas()
                          }}
                    >
                        <i className="ci ci-user me-2"/>
                        <span>{appStore.tr.club_members}</span>
                    </Link>
                </li>
                {/*<li className="d-flex w-100 pt-1">*/}
                {/*    <Link to="/manager/branch/new"*/}
                {/*          className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"*/}
                {/*          onClick={() => {*/}
                {/*              closeOffcanvas()*/}
                {/*          }}>*/}
                {/*        <i className="ci ci-plus-square me-2"/>*/}
                {/*        <span>{appStore.tr.add_branch}</span>*/}
                {/*    </Link>*/}
                {/*</li>*/}
                <li className="d-flex w-100 pt-1">
                    <Link to="/manager/branch/list"
                          className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"
                          onClick={() => {
                              closeOffcanvas()
                          }}
                    >
                        <i className="ci ci-home me-2"/>
                        <span>{appStore.tr.branches}</span>
                    </Link>
                </li>
                {/*<li className="d-flex w-100 pt-1">*/}
                {/*    <Link to="/manager/team/new"*/}
                {/*          className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"*/}
                {/*          onClick={() => {*/}
                {/*            closeOffcanvas()*/}
                {/*          }}>*/}
                {/*        <i className="ci ci-plus-circle me-2"/>*/}
                {/*        <span>{appStore.tr.add_team}</span>*/}
                {/*    </Link>*/}
                {/*</li>*/}
                <li className="d-flex w-100 pt-1">
                    <Link
                        to="/manager/team/list"
                        className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"
                        onClick={() => {
                            closeOffcanvas()
                        }}
                    >
                        <i className="ci ci-briefcase me-2"/>
                        <span>{appStore.tr.teams}</span>
                    </Link>
                </li>
                {clubStore.club.children.map(child => child.is_manager &&
                    <React.Fragment key={child.id}>
                        <li className="mt-1">
                            <b>{child.name}</b>
                        </li>
                        <li className="d-flex w-100">
                            <Link
                                to="/manager/team/list"
                                className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"
                                onClick={() => {
                                    clubStore.teamQuery.setProperty('company_id', child.id)
                                    closeOffcanvas()
                                }}
                            >
                                <i className="ci ci-briefcase me-2"/>
                                <span>{appStore.tr.teams}</span>
                            </Link>
                        </li>
                    </React.Fragment>
                )}
            </ul>
        }

    </div>
  );
};

export default observer(ManagerMenu);